import { useEffect, useState, lazy } from 'react';
import { createPortal } from 'react-dom';
import Collapse from 'react-bootstrap/Collapse';
import { useStore } from '../hooks/useStore';
import useAppData from '../hooks/useAppData';
import useClearOrder from '../hooks/useClearOrder';
import { format, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

import {
  Banner, Button
} from '../styles/styles.js';

const MiniBasket = lazy(() => import('./Booking/MiniBasket'));

const Timer = (props) => {
  const [state, dispatch] = useStore();
  const { appData, tickets, section, timerActive, calendarType, clientState, pageSlug,
    selectedDate, selectedDateTime, selectedTime, dateContext } = state;
  const { clearOrder } = useClearOrder();
  const [isActive, setIsActive] = useState(false);
  const [formattedDate, setFormattedDate] = useState(null);
  const [formattedTime, setFormattedTime] = useState(null);
  const [ticketType, setTicketType] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [formattedCountdown, setFormattedCountdown] = useState('');
  const [startingTimer, setStartingTimer] = useState(false);
  const [showLink, setShowLink] = useState(false);
  // const [startOver, setStartOver] = useState(false);

  const { cartElement } = useAppData();

  useEffect(() => {
    if (appData) {
      if (!window.location.pathname.includes(appData.gift_redemption_page.post_name) && !window.location.pathname.includes(appData.ticketing_page.post_name)) setShowLink(true);
    }
  }, []);

  useEffect(() => {
    if (timerActive) {
      // console.log('timerActive', selectedDateTime);
      const UTCdate = utcToZonedTime(parseISO(selectedDateTime), 'UTC');
      setFormattedDate(format(UTCdate, 'EEEE, do MMMM yyyy'));
      setFormattedTime(format(UTCdate, 'HH:mm'));
      // console.log('clientState.sessionRemaining', clientState.sessionRemaining);
      const minutes = appData.timeout_time * 60;
      const session = clientState.sessionRemaining ? clientState.sessionRemaining : minutes;
      setTimeRemaining(session);
      // console.log('session', session);
      if (!isActive) {
        setTimeout(() => {
          setStartingTimer(true);
          showTimer();
        }, 1000);
      }
    } else {
      hideTimer();
    }
  }, [timerActive, selectedDateTime]);

  useEffect(() => {
    const sessionTime = clientState.sessionRemaining;
    if (sessionTime && timerActive) {
      console.log('sessionTime 2', sessionTime);
      setTimeRemaining(sessionTime);
      showTimer();
    }
  }, [clientState]);

  useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setTimeRemaining(countdown());
      }, 1000);
    } else if (!isActive || timeRemaining === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive, timeRemaining]);

  const showTimer = () => {
    // console.log('showTimer');
    document.body.classList.add("has-timer");
    setIsActive(true);
    setStartingTimer(false);
  }
  const hideTimer = () => {
    // console.log('hideTimer');
    document.body.classList.remove("has-timer");
    setIsActive(false);
  }
  const countdown = () => {
    // console.log('timeRemaining', timeRemaining);
    if (timeRemaining === 0 && !startingTimer) {
      hideTimer();
      dispatch('SET', { dateTimeConfirmed: false });
      window.location.href = clientState.orderID ? appData.gift_redemption_page.guid : appData.ticketing_page.guid;
      return null;
    }
    const count = timeRemaining - 1;
    const minutes = Math.floor(count / 60);
    const seconds = count - (minutes * 60);
    const formatted = minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
    setFormattedCountdown(formatted);
    return count;
  }
  const returnToTickets = () => {
    // console.log('returnToTickets');
    if (window.location.pathname.includes(pageSlug) && window.location.pathname.includes(ticketType)) dispatch('SET', { 'step': 3 });
    else if (calendarType === 'redemption') window.location.href = '/gift-tickets/redeem';
    // else window.location.href = `/${pageSlug}/${ticketType}`;
    else window.location.href = `/${pageSlug}/#${section}`;
  }
  const CTA = () => {
    // const ctaText = calendarType === 'booking' ? 'Complete your purchase' : 'Redeem your tickets';
    if (showLink) {
      return (
        <div><strong onClick={() => returnToTickets()}><u>Complete your purchase</u></strong></div>
      );
    }
    return '';
  }

  const DateTimeStatus = () => {
    if (!formattedDate) {
      return '';
    }
    return (
      <>for <strong> {formattedDate} at {formattedTime} </strong></>
    );
  }

  return (
    <>
      {cartElement && createPortal(<MiniBasket />, cartElement)}
      <Collapse mountOnEnter={true} unmountOnExit={true} in={isActive}>
        <Banner onClick={() => returnToTickets()}>
          <div>Your visit <DateTimeStatus /> is reserved for {formattedCountdown}. <strong onClick={clearOrder}>Reset</strong></div>
          {/* <div>Your visit <DateTimeStatus/> is reserved for {formattedCountdown}.</div> */}
          <CTA />
        </Banner>
      </Collapse>
    </>
  );
}

export default Timer;
